module.exports = __webpack_public_path__ + "static/media/MQ.73bfb484.svg";